module.exports = __webpack_public_path__ + "static/img/science_technology_intensity_thumbnail.0694883.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/science_technology_intensity_thumbnail.jpg
// module id = Iu9W
// module chunks = 6